import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment-jalaali";
import config from "../../../utils/config";
import { separateNum } from "../../../utils";
import { setUser } from "../../../store/action/auth";
import HttpService from "../../../services/http_service/HttpService";
import Http from "../../../services/http/Http";
import Card from "../../../components/card";
import Loading from "./loading";
import Empty from "./empty";
import {
  Div,
  Container,
  TransactionTitle,
  TransactionDate,
  TransactionMsg,
  TransactionPrice,
} from "./style";

moment.loadPersian({ usePersianDigits: true });

const Transactions = (props) => {
  const { theme, user } = props;

  const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const getTransactions = useCallback(() => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .get("user/transactions")
      .then((response) => {
        setTransactions(response.data?.entity);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  }, [user, props]);

  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  return (
    <>
      <Div className="mx-1 mt-3 text-right">
        {isLoadingGetData ? (
          <Loading />
        ) : transactions.length ? (
          <Container>
            {transactions.map((transaction, index) => (
              <Card key={index} className="p-2 mb-2">
                <Div className="d-inline-block vertical-align-top">
                  {Number(transaction?.status) === 2 ? (
                    <i className="fal fa-check-circle color-app f-15"></i>
                  ) : (
                    <i className="fal fa-times-circle color-red f-15"></i>
                  )}
                </Div>
                <Div className="d-inline-block mr-4">
                  <TransactionTitle className="f-13" theme={theme}>
                    پرداخت اینترنتی - {transaction.status_text}
                  </TransactionTitle>
                  <TransactionDate className="f-12 mt-1" theme={theme}>
                    {moment(transaction.created_at, "YYYY-M-D HH:mm:ss").format(
                      "jD jMMMM ساعت HH:mm"
                    )}
                  </TransactionDate>
                  <TransactionMsg className="mt-3 f-13" theme={theme}>
                    پرداخت برای شماره فاکتور {transaction?.order?.tracking_code}
                  </TransactionMsg>
                </Div>
                <TransactionPrice
                  className="d-inline-block float-left"
                  theme={theme}
                >
                  {separateNum(transaction.price)} {config.currency}
                </TransactionPrice>
              </Card>
            ))}
          </Container>
        ) : (
          <Empty />
        )}
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser })(Transactions);
